/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import socketService from '../services/socketService';
import { useParams } from 'react-router-dom';
import { kitchenHandler } from '../redux/handlers';
export function useSocketLogout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { businessSlug } = useParams();
  const [email, setEmail] = useState(() => localStorage.getItem('email') || '');
  const [kitchenId, setKitchenId] = useState(() => localStorage.getItem('branchKitchenId') || '');

  useEffect(() => {
    const checkEmail = () => {
      const storedEmail = localStorage.getItem('email');
      if (storedEmail !== email) {
        setEmail(storedEmail || '');
      }
    };

    window.addEventListener('focus', checkEmail);

    return () => {
      window.removeEventListener('focus', checkEmail);
    };
  }, [email]);

  useEffect(() => {
    let cleanupHandler = null;

    if (email) {
      if (!socketService.businessGroupChannel) {
        socketService.setBusinessGroup(email);
      }
      console.log('เริ่มต้นการตรวจสอบ จาก server : ', email);
      cleanupHandler = socketService.registerLogoutHandler(() => {
        if (kitchenId) {
          console.log('ได้รับคำสั่ง logout จาก server');
          dispatch(kitchenHandler.logoutKitchen(businessSlug, Number(kitchenId)));
          localStorage.removeItem('email');
          localStorage.removeItem('branchId');
          localStorage.removeItem('branchPOSId');
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('branchKitchenId');
          socketService.disconnect();
          navigate(`/${businessSlug}/login`, { replace: true });
        } else {
          console.log('ได้รับคำสั่ง logout จาก server');
          localStorage.removeItem('branchPOSId');
          localStorage.removeItem('email');
          localStorage.removeItem('branchId');
          localStorage.removeItem('accessToken');
          localStorage.removeItem('branchPOSSelling');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('closePrintObj');
          socketService.disconnect();
          navigate(`/${businessSlug}/login`, { replace: true });
        }
      });
    }

    return () => {
      if (cleanupHandler) {
        cleanupHandler();
      }
    };
  }, [email, dispatch, navigate, businessSlug]);
}
